// `image.analysis`: a reference image's analysis (G8 PR 3a).
// The Advanced mode starts it for a reference, not a Studio draft.
import { ImageAnalysisQuote, ImageAnalysisRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"image.analysis"> = {
  type: "image.analysis",
  label: "Image analysis",
  source: "form",
  pair: "image.analysis",
  fields: (draft) => commonFields(draft),
  request: ImageAnalysisRequest,
  quote: ImageAnalysisQuote,
};
